module.exports = __webpack_public_path__ + "media/styles/images/png/move-white-5df85f468e7ed59d03324a1c5d27b472.png";